import * as React from "react";
import { AppService, Types } from '../../Services/AppService';

class OidcLoginRedirect extends React.Component {

    public async componentDidMount() {

        const result = await AppService.get(Types.Neo.Security.AuthenticationService).tryCompleteSignIn();
        if (result.success) {

            const navigation = AppService.get(Types.Neo.Routing.NavigationHelper);
            
            if (result.redirectPath) {
                navigation.navigateInternal(result.redirectPath, true);
            } else {
                navigation.navigateInternal("/", true);
            }
        }
    }

    public render() {
        return <div>Signing in...</div>
    }
}

export default OidcLoginRedirect;